import {appraisalTemplateQuestionTypes} from 'constants';

/**
 * Resolves a question's raw answer value into its human-readable display text.
 * @param {Object} question The question the answer belongs to.
 * @param {string} answer The raw answer value (option id for mcq, body text for free_text).
 * @return {string} The display text.
 */
export function formatAnswer(question, answer) {
  if (!answer) {
    return '';
  }
  if (question.questionType === appraisalTemplateQuestionTypes.MCQ) {
    const option = question.options.find((item) => item.id === answer);
    return option ? option.body : '';
  }
  return answer;
}
